var exports = {
  "CQ": "BarrierComponents.module__systemNotice___WTR5aj",
  "W1": "BarrierComponents.module__systemEmblem___WTR5aj",
  "AD": "BarrierComponents.module__systemVerified___WTR5aj",
  "xj": "BarrierComponents.module__systemNoticeText___WTR5aj",
  "Tw": "BarrierComponents.module__systemLearnMore___WTR5aj",
  "i7": "BarrierComponents.module__systemInfoParagraph___WTR5aj",
  "_f": "BarrierComponents.module__barrierLayout___WTR5aj",
  "Rt": "BarrierComponents.module__barrierLayoutNoAction___WTR5aj",
  "Kk": "BarrierComponents.module__icon___WTR5aj",
  "vV": "BarrierComponents.module__messageArea___WTR5aj",
  "iU": "BarrierComponents.module__message___WTR5aj",
  "C$": "BarrierComponents.module__actionArea___WTR5aj",
  "O1": "BarrierComponents.module__timer___WTR5aj",
};

module.exports = exports;
